var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F07676",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01158 7.27409H8.7984V16H10.7375V8.35747L13.6461 9.81188V15.9997H15.5853V9.21284C15.5854 9.03277 15.5354 8.85626 15.4407 8.70292C15.3462 8.54973 15.2108 8.4258 15.0496 8.34515L10.7375 6.1903V5.33476H10.7157C10.5487 3.49423 9.44073 1.87123 7.78718 1.04565C6.1338 0.220064 4.17065 0.309487 2.59924 1.28201C1.02784 2.25454 0.071716 3.97133 0.0727548 5.8194V15.9996H2.01189L2.01158 7.27409ZM5.40491 2.42637C6.22019 2.42721 7.00791 2.72174 7.62404 3.25585C8.23996 3.78996 8.64306 4.52799 8.75954 5.33496H2.05019C2.16668 4.52794 2.56976 3.78996 3.18569 3.25585C3.80178 2.72173 4.58954 2.42719 5.40482 2.42637H5.40491ZM3.95046 8.9708H6.85905V10.9099H3.95046V8.9708ZM6.85905 12.849H3.95046V14.7881H6.85905V12.849Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.f09cc6361bfac5646c750652c44495b7.svg";
export { ForwardRef as ReactComponent };